export const MFAErrorCode = 4010002;
export const Aal2RequiredCode = "session_aal2_required";
